export const DOCUMENT_WIDTH = '85ch';
export const PENDING_AI_GENERATION = 'AI_GENERATION';

// For workflow resources (e.g. "workflows/abc/instances/xyz"), uses the
// instance ID. For other resources, replaces slashes with dashes.
export function getCollaborativeDocumentName(resource: string): string {
  const parts = resource.split('/');
  const isWorkflowResource = parts.length >= 4 && parts[0] === 'workflows';

  const collaborativeDocumentId = isWorkflowResource
    ? parts[3]
    : resource.replace(/\//g, '-');

  return `collaborativeDocuments/${collaborativeDocumentId}`;
}
